import React from "react";
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "../../../components/ui/card";
import { Link } from "react-router-dom";
import { Check, Calendar, Users, HardDrive } from "lucide-react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Divider,
  Typography,
} from "@material-ui/core";

const PaymentSuccess = (props) => {
  const { handleNavigate, plansDetail, paymentMethod } = props;
  const displayDate =
    plansDetail?.recurring?.interval === "year"
      ? new Date(Date.now() + 365 * 24 * 60 * 60 * 1000).toLocaleDateString() // Adds 1 year
      : new Date(Date.now() + 30 * 24 * 60 * 60 * 1000).toLocaleDateString(); // Adds 30 days
  
  const isACH = paymentMethod === "ach" || paymentMethod === "us_bank_account";

  return (
    <div className="min-h-screen bg-slate-50 flex flex-col items-center justify-start py-12 px-4 sm:px-6 lg:px-8  dark:bg-[#1A1F2C] dark:text-white">
      <Card className="w-full max-w-lg dark:bg-[#1A1F2C] dark:text-white dark:shadow-[0_0_12px_rgba(2,8,23,0.8)] ">
        <CardHeader className="text-center p-24">
          <div className="mx-auto bg-green-100 rounded-full p-3 w-16 h-16 flex items-center justify-center mb-4">
            <Check className="h-8 w-8 text-green-600" />
          </div>
          <CardTitle className="text-2xl font-bold text-green-600">
            {isACH ? "Thank You — Your ACH Payment Is Being Processed" : "Thank you for your purchase!"}
          </CardTitle>
        </CardHeader>
        <CardContent className="space-y-6 ph-24 pb-24 pt-0">
          <div className="text-center">
            <p className="text-gray-600 dark:text-white">
             {isACH ? "Your ACH payment is processing. Your subscription will activate once the payment is confirmed." : " Your subscription is now active. You now have full access to all premium features."}
            </p>
          </div>

          {isACH && (
            <div className="bg-yellow-50 p-16 rounded-lg border border-yellow-200 dark:bg-[#1A1F2C] dark:border-0 dark:shadow-[0_0_12px_rgba(255,255,0,0.2)] mt-8">
              <h3 className="font-medium text-lg text-yellow-700 mb-8 dark:text-yellow-400">
                ACH Payment Processing
              </h3>
              <p className="text-sm text-gray-700 dark:text-white">
                Your ACH payment is still being processed. This may take a few business days. Once the transaction is successfully completed, your subscription status will automatically update in the system.
              </p>
            </div>
          )}

          <div className="bg-green-50 p-20 rounded-lg border border-green-100 dark:bg-[#1A1F2C] dark:shadow-[0_0_12px_rgba(2,8,23,0.8)] dark:border-0">
            <h3 className="font-medium text-lg text-gray-900 mb-4 dark:text-green-600">
              Subscription Details
            </h3>
            <div className="space-y-4">
              <div className="flex items-center gap-3">
                <div className="bg-green-100 p-4 rounded-full">
                  <Users className="h-5 w-5 text-green-600" />
                </div>
                <div>
                  <p className="text-sm font-medium">User seats</p>
                  <p className="text-sm text-gray-600 dark:text-white">
                    Manage your team members in settings
                  </p>
                </div>
              </div>

              <div className="flex items-center gap-3">
                <div className="bg-green-100 p-4 rounded-full">
                  <HardDrive className="h-5 w-5 text-green-600" />
                </div>
                <div>
                  <p className="text-sm font-medium">Storage</p>
                  <p className="text-sm text-gray-600 dark:text-white">
                    Your storage has been upgraded
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="bg-blue-50 p-16 rounded-lg dark:bg-[#1A1F2C] dark:shadow-[0_0_12px_rgba(2,8,23,0.8)] ">
            <h3 className="font-medium text-lg text-gray-900 mb-4 dark:text-green-600">What's next?</h3>
            <ul className="space-y-3">
              <li className="flex gap-2">
                <Check className="h-5 w-5 text-blue-500 flex-shrink-0 dark:text-[#008000]" />
                <span className="text-gray-700 dark:text-white">
                  Set up your team members in the dashboard
                </span>
              </li>
              <li className="flex gap-2">
                <Check className="h-5 w-5 text-blue-500 flex-shrink-0 dark:text-[#008000]" />
                <span className="text-gray-700 dark:text-white">
                  Explore your new premium features
                </span>
              </li>
              <li className="flex gap-2">
                <Check className="h-5 w-5 text-blue-500 flex-shrink-0 dark:text-[#008000]" />
                <span className="text-gray-700 dark:text-white">
                  Contact support if you need any assistance
                </span>
              </li>
            </ul>
          </div>

          <div className="text-center space-y-4 pt-4">
            <Button
              className="w-full bg-green-600 hover:bg-green-700"
              style={{ backgroundColor: "green", color: "white" }}
              onClick={handleNavigate}
            >
              Go to Dashboard
            </Button>

            <div className="pt-2">
              <p className="text-sm text-gray-500 mb-4 dark:text-white">
                We've sent a confirmation email with all the details to your
                registered email address.
              </p>
              <Link
                to="/help/support"
                className="text-sm text-green-600 hover:text-green-500"
              >
                Need help? Contact support
              </Link>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default PaymentSuccess;

export function SuccessDowngradeDialog({ open, onClose, data, change }) {
  const formatStripeAmount = (amount) => {
    return `$${(Math.abs(amount) / 100).toFixed(0)}`;
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <Typography
        variant="h6"
        align="center"
        className="mt-20 text-[#020817] dark:bg-[#1A1F2C] dark:text-green-600"
        style={{ fontSize: "22px", fontWeight: 700 }}
      >
        {change === true
          ? "Subscription Updated Successfully"
          : "Subscription Downgraded Successfully"}
      </Typography>

      <Divider className="mt-10" />

      <DialogContent
       className="text-[#334155] dark:bg-[#1A1F2C]  dark:text-[#6B7280]"
        style={{
          fontSize: "15px",
          lineHeight: "1.8",
          paddingTop: "16px",
        }}
      >
        <Typography variant="body" style={{ fontWeight: 600, fontSize:"16px" }} className="text-[#020817] dark:bg-[#1A1F2C] dark:text-white">
          {change === true
            ? "Your subscription has been updated successfully."
            : "Your subscription has been downgraded successfully. Below are the updated details:"}
        </Typography>

        <div style={{ marginTop: "12px" }} className="dark:bg-[#1A1F2C]">
          {change === false && (
            <>
            <div className="updateDialog">
              <Typography variant="body" className="text-[#020817] dark:text-white" style={{ fontWeight: 600, fontSize:"16px" }}>
              • {data?.daysUsed} days used from {data?.OldProduct}
              </Typography>
            </div>
            <div className="updateDialog">
              <Typography variant="body"className="updateDialogName text-[#020817] dark:text-white" style={{ fontWeight: 600, fontSize:"16px" }}>
              • Used Balance :
              </Typography>
              <Typography variant="body" className="updateDialogLabel dark:text-[#F1F5F9]" style={{ marginLeft: "10px", fontWeight: 500, fontSize:"16px" }}>
                {`${formatStripeAmount(data?.usedFromOldPlan || 0)} (${data?.daysUsed} Day of Use)`}
              </Typography>
            </div>
            <div className="updateDialog">
              <Typography variant="body" className="updateDialogName text-[#020817] dark:text-white" style={{ fontWeight: 600, fontSize:"16px" }}>
              • Credits Owed :
              </Typography>
              <Typography variant="body" className="updateDialogLabel dark:text-[#F1F5F9]" style={{ marginLeft: "10px", fontWeight: 500, fontSize:"16px" }}>
                {formatStripeAmount(data?.creditFromOldPlan || 0)}
              </Typography>
            </div>
            <div className="updateDialog">
              <Typography variant="body" className="updateDialogName text-[#020817] dark:text-white" style={{ fontWeight: 600, fontSize:"16px" }}>
              • New Bill :
              </Typography>
              <Typography variant="body" className="updateDialogLabel dark:text-[#F1F5F9]" style={{ marginLeft: "10px", fontWeight: 500, fontSize:"16px" }}>
                {`${formatStripeAmount(data?.costForNewPlan || 0)} (${data?.NewProduct})`}
              </Typography>
            </div>
            <div className="updateDialog">
              <Typography variant="body" className="updateDialogName text-[#020817] dark:text-white" style={{ fontWeight: 600, fontSize:"16px" }}>
              • Future Credit :
              </Typography>
              <Typography variant="body" className="updateDialogLabel dark:text-[#F1F5F9]" style={{ marginLeft: "10px", fontWeight: 500, fontSize:"16px" }}>
                {formatStripeAmount(data?.currentBalanceAfterCredit || 0)}
              </Typography>
            </div>
            </>
          )}

          <Typography variant="body" style={{ fontWeight: 600, fontSize:"16px" }} className=" dark:bg-[#1A1F2C] dark:text-white text-[#020817]">
            {change === true
              ? "Your subscription has been changed. No additional charges or credits are applicable at this time."
              : "Your available credits will be automatically applied to your next billing cycle or future subscription changes."}
          </Typography>
        </div>
      </DialogContent>

      <DialogActions className="d-flex flex-justify-center mb-15">
        <Button
          variant="contained"
          onClick={onClose}
          style={{
            backgroundColor: "#16a34a",
            color: "#ffffff",
            borderRadius: "8px",
            padding: "8px 24px",
            textTransform: "none",
            fontWeight: 600,
          }}
        >
          Go to Dashboard
        </Button>
      </DialogActions>
    </Dialog>
  );
}

const DetailRow = ({ label, value }) => (
  <div style={{ display: "flex", marginBottom: 10 }}>
    <Typography
      variant="body2"
      style={{ fontWeight: 600, color: "#F1F5F9", fontSize: 15 }}
    >
      {label}
    </Typography>
    {value && (
      <Typography
        variant="body2"
        style={{ marginLeft: 10, fontWeight: 500, color: "#020817", fontSize: 15 }}
      >
        {value}
      </Typography>
    )}
  </div>
);


export function DowngradeDetailsDialog({ open, onConfirm, onClose, data, balance, newPrice }) {
  const formatStripeAmount = (amount) => {
    return `$${(Math.abs(amount) / 100).toFixed(0)}`;
  };

  const BASE_PRICE_MAP = [
  { name: "Standard", amount: 9900 },
  { name: "Plus", amount: 24900 },
  { name: "Professional", amount: 37500 },
  { name: "Standard", amount: 99000 },
  { name: "Plus", amount: 249900 },
  { name: "Professional", amount: 375000 },
  ];
  const PRICE_IDS_BY_ENV = {
    dev: [
      "price_1RY2GjH54HzvHwSd7xIHfw9Z",
      "price_1RY2L2H54HzvHwSdeCNKydVJ",
      "price_1RY2SdH54HzvHwSdE62LQFMq",
      "price_1RYSEYH54HzvHwSdWnZO85Pk",
      "price_1RYSH0H54HzvHwSdPNwhG0Zf",
      "price_1RbFRkH54HzvHwSd8QpK4ZPQ",
    ],
    stage: [
      "price_1Rg4StHG9KfCFcBtk62AyLjl",
      "price_1Rg4VOHG9KfCFcBtUdpounGQ",
      "price_1Rg4YeHG9KfCFcBthKGhErSl",
      "price_1Rg4TIHG9KfCFcBti234fUD6",
      "price_1Rg4VsHG9KfCFcBtOKbt91yg",
      "price_1Rg4ZuHG9KfCFcBtO4Q6Y12k",
    ],
    prod: [
      "price_1RsdHLHPX5Uwv3eVePGNLRLj",
      "price_1RsdPgHPX5Uwv3eV7k7eyln8",
      "price_1RsdVFHPX5Uwv3eVbavvVBji",
      "price_1RsdLlHPX5Uwv3eV3ozmcddw",
      "price_1RsdQBHPX5Uwv3eVmDc1CW9P",
      "price_1RsdVaHPX5Uwv3eVGScEMH75",
    ],
  };
  const ENV = process.env.REACT_APP_CUSTOM_ENV || "dev";

  const priceIds = PRICE_IDS_BY_ENV[ENV];
  const priceMap = {};

  priceIds?.forEach((id, index) => {
    priceMap[id] = BASE_PRICE_MAP[index];
  });

  const subscription = data?.subscriptions?.data?.[0]
  const plan = subscription?.plan?.id
  
    const oldPriceAmount = priceMap[plan]?.amount;
    const newPriceAmount = priceMap[newPrice]?.amount;

    const oldPriceName = priceMap[plan]?.name;
    const newPriceName = priceMap[newPrice]?.name;

    const interval = subscription.plan.interval;
    const periodStart = subscription.current_period_start || data?.subscriptionDetails.current_period_start || subscription.billing_cycle_anchor;
    const periodEnd = subscription.current_period_end || data?.subscriptionDetails.current_period_end; 

    const SECONDS_IN_A_DAY = 60 * 60 * 24;
    const totalPeriodDays =
      interval === "month"
        ? 30
        : Math.ceil((periodEnd - periodStart) / SECONDS_IN_A_DAY);

    const secondsUsed = Date.now() / 1000 - periodStart;
    const daysUsed = Math.floor(secondsUsed / SECONDS_IN_A_DAY);
    const daysRemaining = totalPeriodDays - daysUsed;

    const oldDailyRate = oldPriceAmount / totalPeriodDays;
    const creditFromOldPlan = oldDailyRate * daysRemaining;
    const usedFromOldPlan = oldDailyRate * daysUsed;

    const finalAmountDue = Math.round(newPriceAmount - creditFromOldPlan + (balance || 0));
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <Typography
        variant="h6"
        align="center"
        className="mt-20 text-[#020817] dark:text-green-600"
        style={{ fontSize: 22, fontWeight: 700, paddingTop: "20px" }}
      >
        Subscription Downgrade Details
      </Typography>

      <Divider style={{ marginTop: 12 }} />

      <DialogContent
      className="dark:bg-[#1A1F2C]"
        style={{
          paddingTop: 24,
          paddingBottom: 8,
          fontSize: 15,
          lineHeight: 1.8,
          color: "#334155",
        }}
      >
        <div style={{ marginTop: 16, paddingLeft: 8 }} className="dark:bg-[#1A1F2C] ">
           <div className="updateDialog">
              <Typography variant="body" className="text-[#020817] dark:text-white" style={{ fontWeight: 600, fontSize:"16px" }}>
              • {daysUsed} days used from {oldPriceName}
              </Typography>
            </div>
            <div className="updateDialog">
              <Typography variant="body" className="updateDialogName text-[#020817] dark:text-white" style={{ fontWeight: 600, fontSize:"16px" }}>
              • Used Balance :
              </Typography>
              <Typography variant="body" className="updateDialogLabel dark:text-[#F1F5F9]" style={{ marginLeft: "10px", fontWeight: 500, fontSize:"16px" }}>
                {`${formatStripeAmount(usedFromOldPlan || 0)} (${daysUsed} Day of Use)`}
              </Typography>
            </div>
            <div className="updateDialog">
              <Typography variant="body" className="updateDialogName text-[#020817] dark:text-white" style={{ fontWeight: 600, fontSize:"16px" }}>
              • Credits Owed :
              </Typography>
              <Typography variant="body" className="updateDialogLabel dark:text-[#F1F5F9]" style={{ marginLeft: "10px", fontWeight: 500, fontSize:"16px" }}>
                {formatStripeAmount(creditFromOldPlan || 0)}
              </Typography>
            </div>
            <div className="updateDialog">
              <Typography variant="body" className="updateDialogName text-[#020817] dark:text-white" style={{ fontWeight: 600, fontSize:"16px" }}>
              • New Bill :
              </Typography>
              <Typography variant="body" className="updateDialogLabel dark:text-[#F1F5F9]" style={{ marginLeft: "10px", fontWeight: 500, fontSize:"16px" }}>
                {`${formatStripeAmount(newPriceAmount || 0)} (${newPriceName})`}
              </Typography>
            </div>
            <div className="updateDialog">
              <Typography variant="body" className="updateDialogName text-[#020817] dark:text-white" style={{ fontWeight: 600, fontSize:"16px" }}>
              • Future Credit :
              </Typography>
              <Typography variant="body" className="updateDialogLabel dark:text-[#F1F5F9]" style={{ marginLeft: "10px", fontWeight: 500, fontSize:"16px" }}>
                {formatStripeAmount(finalAmountDue || 0)}
              </Typography>
            </div>
        </div>

        <Typography
          variant="body1"
          className="dark:bg-[#1A1F2C] dark:text-white text-[#020817]"
          style={{
            marginTop: 24,
            fontWeight: 600,
            fontSize: 18,
          }}
        >
          Are you sure you want to proceed ?
        </Typography>
      </DialogContent>

      <DialogActions style={{ paddingBottom: 20 }} className="dark:bg-[#1A1F2C]">
        <Button
          variant="contained"
          onClick={onClose}
          className="dark:bg-[#808080] bg-[#F1F5F9] text-[#020817] dark:text-white"
          style={{
            borderRadius: 8,
            padding: "8px 24px",
            textTransform: "none",
            fontWeight: 600,
            marginRight: 8,
          }}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          onClick={onConfirm}
          style={{
            backgroundColor: "#16a34a",
            color: "#ffffff",
            borderRadius: 8,
            padding: "8px 24px",
            textTransform: "none",
            fontWeight: 600,
          }}
        >
          Proceed
        </Button>
      </DialogActions>
    </Dialog>
  );
}